var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/js/Components/BaseForm.tsx
import React2, { useCallback } from "react";
import { FormProvider } from "react-hook-form";

// src/js/Hooks/DisabledContext.ts
import { createContext, useContext } from "react";
var Context = createContext(void 0);
var DisabledProvider = Context.Provider;
var useDisabled = () => useContext(Context);

// src/js/Hooks/LoadingContext.ts
import { createContext as createContext2, useContext as useContext2 } from "react";
var Context2 = createContext2(void 0);
var LoadingProvider = Context2.Provider;
var useLoading = () => useContext2(Context2);

// src/js/Hooks/SubmitContext.ts
import { createContext as createContext3, useContext as useContext3 } from "react";
var Context3 = createContext3(null);
var SubmitProvider = Context3.Provider;
var useSubmit = (submitButton) => {
  var _a;
  return (_a = useContext3(Context3)) == null ? void 0 : _a(submitButton);
};

// src/js/Components/BaseForm.tsx
function BaseForm({
  form,
  onSubmit,
  disabled = false,
  className,
  loading = false,
  children
}) {
  const handleSubmit = useCallback((submitButton) => {
    return form.handleSubmit((data, event) => onSubmit == null ? void 0 : onSubmit(data, event, submitButton));
  }, [form, onSubmit]);
  return /* @__PURE__ */ React2.createElement("form", { className, onSubmit: onSubmit && form.handleSubmit(onSubmit) }, /* @__PURE__ */ React2.createElement(FormProvider, __spreadValues({}, form), /* @__PURE__ */ React2.createElement(LoadingProvider, { value: loading }, /* @__PURE__ */ React2.createElement(SubmitProvider, { value: handleSubmit }, /* @__PURE__ */ React2.createElement(DisabledProvider, { value: disabled }, children)))));
}

// src/js/Components/Form.tsx
import { AxiosError } from "axios";
import React3, { useCallback as useCallback2, useState } from "react";
import { useTranslation } from "react-i18next";

// src/js/FormError.ts
var FormError = class extends Error {
  constructor(errors, message) {
    super(message);
    this.errors = errors;
  }
};

// src/js/Components/Form.tsx
function Form(_a) {
  var _b = _a, { onSubmit, form } = _b, props = __objRest(_b, ["onSubmit", "form"]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const handleSubmit = useCallback2(async (...args) => {
    var _a2, _b2;
    setLoading(true);
    try {
      await (onSubmit == null ? void 0 : onSubmit(...args));
    } catch (e) {
      if (e instanceof FormError) {
        for (const [key, value] of Object.entries(e.errors)) {
          form.setError(key, {
            type: "manual",
            message: t(value)
          });
        }
      } else if (e instanceof AxiosError && "errors" in ((_a2 = e.response) == null ? void 0 : _a2.data)) {
        for (const [key, value] of Object.entries((_b2 = e.response) == null ? void 0 : _b2.data.errors)) {
          form.setError(key, {
            type: "manual",
            message: t(value)
          });
        }
      } else {
        throw e;
      }
    } finally {
      setLoading(false);
    }
  }, [onSubmit, setLoading]);
  return /* @__PURE__ */ React3.createElement(
    BaseForm,
    __spreadValues({
      form,
      onSubmit: handleSubmit,
      loading
    }, props)
  );
}

// src/js/functions.ts
function setFormErrors(form, errors) {
  for (const [key, value] of Object.entries(errors)) {
    if (value !== void 0) {
      form.setError(key, {
        type: "manual",
        message: value
      });
    }
  }
}
function setFormValues(form, values) {
  for (const [key, value] of Object.entries(values)) {
    if (value !== void 0) {
      form.setValue(key, value);
    }
  }
}
export {
  BaseForm,
  DisabledProvider,
  Form,
  FormError,
  LoadingProvider,
  SubmitProvider,
  setFormErrors,
  setFormValues,
  useDisabled,
  useLoading,
  useSubmit
};
